<!-- 查询车场支付记录接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure";

  export default {
    name: "",
    components: {
      "right-structure": structure
    },
    props: ["commonUrls"],
    data() {
      return {
        requestBody: {
          "parkCode": "2KKN885K",
          "payTimeStart": "20200226000000",
          "payTimeEnd": "20200226235959",
          "pageNum": 1,
          "pageSize": 10
        },
        responseCode: {
          "data": {
            "currCount": 2,
            "recordList": [
              {
                "abnormalOpenGate": "否",
                "billCode": "2020022616025813846088",
                "billOriginType": 0,
                "carNo": "粤N11111",
                "carType": 1,
                "couponList": [],
                "enterChannelName": "开发入口1",
                "enterTime": "20200226151923",
                "enterType": 2,
                "invoiceNumber": "",
                "invoicingStatus": 0,
                "leaveType": 2,
                "payMode": 1,
                "payModeRemark": "现金",
                "payOrigin": 1,
                "payOriginRemark": "出入口(VEMS)",
                "payTime": "20200226160249",
                "realValue": 0,
                "reliefValue": 0,
                "shouldValue": 0,
                "tollCollectorName": "akeadmin",
                "topBillCode": "200226151923313834753111",
                "vipType": 2,
                "realInvoiceStatus": 1,
                "invoiceClient": "开票用户端",
                "invoiceCooperator": "开票授权商",
                "vipTypeName": "本地VIP"
              },
              {
                "billCode": "2020022609301039156692",
                "billOriginType": 0,
                "carNo": "京A19746",
                "carType": 2,
                "couponList": [
                  {
                    "couponOrigin": 0,
                    "couponName": "5折",
                    "couponCode": "462",
                    "couponValue": 15,
                    "couponType": 0
                  }
                ],
                "couponReliefValue": 15,
                "enterChannelName": "开发入口1",
                "enterTime": "20200226090000",
                "enterType": 2,
                "invoiceNumber": "",
                "invoicingStatus": 0,
                "payMode": 1,
                "payModeRemark": "现金",
                "payOrigin": 2,
                "payOriginRemark": "中央缴费(VEMS)",
                "payTime": "20200226093010",
                "realValue": 15,
                "reliefValue": 15,
                "shouldValue": 30,
                "tollCollectorName": "hr",
                "topBillCode": "200226090000313442340746",
                "vipType": 1,
                "realInvoiceStatus": -1,
                "vipTypeName": "临时车"
              }
            ]
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台获取支付账单信息",
          t_url: this.commonUrls.test + "getPaymentRecordDetailList",
          p_url: this.commonUrls.prod + "getPaymentRecordDetailList",
          precondition: "无",
          fitSystem: "VEMS传统停车场, 云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [
            {
              titleName: null,
              tabledata: [
                {tableHead: "参数名", tdName: "info1"},
                {tableHead: "是否必填", tdName: "info2"},
                {tableHead: "类型", tdName: "info3"},
                {tableHead: "说明", tdName: "info4"}
              ],
              td: [
                {
                  info1: "parkCode",
                  info2: "是",
                  info3: "String",
                  info4: "停车场编号"
                },
                {
                  info1: "payTimeStart",
                  info2: "否",
                  info3: "String",
                  info4: "支付开始时间， yyyyMMddHHmmss"
                },
                {
                  info1: "payTimeEnd",
                  info2: "否",
                  info3: "String",
                  info4: "支付结束时间， yyyyMMddHHmmss，开始时间与结束时间间隔不能大于3个月"
                },
                {
                  info1: "enterTimeStart",
                  info2: "否",
                  info3: "String",
                  info4: "进场开始时间， yyyyMMddHHmmss"
                },
                {
                  info1: "enterTimeEnd",
                  info2: "否",
                  info3: "String",
                  info4: "进场结束时间， yyyyMMddHHmmss，开始时间与结束时间间隔不能大于1个月"
                },
                {
                  info1: "carNo",
                  info2: "否",
                  info3: "String",
                  info4: "车牌号"
                },
                // {
                //   info1: "cardNo",
                //   info2: "否",
                //   info3: "String",
                //   info4: "卡票号"
                // },
                {
                  info1: "selfCode",
                  info2: "否",
                  info3: "String",
                  info4: "自助码"
                },
                // {
                //   info1: "parkVipType",
                //   info2: "否",
                //   info3: "Integer",
                //   info4: "VIP类型，0 临时车 1 停车场VIP"
                // },
                // {
                //   info1: "payMode",
                //   info2: "否",
                //   info3: "Integer",
                //   info4: "支付方式，参考附录"
                // },
                // {
                //   info1: "payOrigin",
                //   info2: "否",
                //   info3: "Integer",
                //   info4: "支付来源，参考附录"
                // },
                // {
                //   info1: "tollCollectorName",
                //   info2: "否",
                //   info3: "String",
                //   info4: "收费员名称"
                // },
                {
                  info1: "billCode",
                  info2: "否",
                  info3: "String",
                  info4: "订单号"
                },
                // {
                //   info1: "invoicingStatus",
                //   info2: "否",
                //   info3: "Integer",
                //   info4: "开票状态 0:未开票 1:纸质票 2:电子票"
                // },
                // {
                //   info1: "invoiceNumber",
                //   info2: "否",
                //   info3: "String",
                //   info4: "发票号码"
                // },
                {info1: "pageNum", info2: "是", info3: "int", info4: "当前页"},
                {
                  info1: "pageSize",
                  info2: "是",
                  info3: "int",
                  info4: "每页多少条，取值范围：1-100"
                }
              ]
            }
          ],
          R_params: [
            {
              titleName: null,
              tabledata: [
                {tableHead: "参数名", tdName: "info1"},
                {tableHead: "是否必填", tdName: "info2"},
                {tableHead: "类型", tdName: "info3"},
                {tableHead: "说明", tdName: "info4"}
              ],
              td: [
                {
                  info1: "total",
                  info2: "是",
                  info3: "Integer",
                  info4: "总数"
                },
                {
                  info1: "currCount",
                  info2: "是",
                  info3: "Integer",
                  info4: "当前获取的记录数"
                },
                {
                  info1: "recordList",
                  info2: "是",
                  info3: "JSONArray",
                  info4: "记录列表"
                }
              ]
            },
            {
              titleName: "recordList",
              tabledata: [
                {tableHead: "参数名", tdName: "info1"},
                {tableHead: "是否必填", tdName: "info2"},
                {tableHead: "类型", tdName: "info3"},
                {tableHead: "说明", tdName: "info4"}
              ],
              td: [
                {
                  info1: "parkingCode",
                  info2: "是",
                  info3: "String",
                  info4: "停车流水号"
                },
                {
                  info1: "billCode",
                  info2: "是",
                  info3: "String",
                  info4: "订单编号"
                },
                {
                  info1: "thirdBillCode",
                  info2: "否",
                  info3: "String",
                  info4: "第三方流水号（微信、支付宝等）"
                },
                {
                  info1: "carNo",
                  info2: "是",
                  info3: "String",
                  info4: "车牌号码"
                },
                {
                  info1: "cardNo",
                  info2: "否",
                  info3: "String",
                  info4: "卡/票号"
                },
                {
                  info1: "enterTime",
                  info2: "是",
                  info3: "String",
                  info4: "进场时间，格式 yyyyMMddHHmmss"
                },
                {
                  info1: "enterChannelName",
                  info2: "是",
                  info3: "String",
                  info4: "进场通道名称"
                },
                {
                  info1: "abnormalOpenGate",
                  info2: "否",
                  info3: "String",
                  info4: "异常开闸"
                },
                {
                  info1: "carType",
                  info2: "否",
                  info3: "Integer",
                  info4: "车辆类型"
                },
                {
                  info1: "enterType",
                  info2: "否",
                  info3: "Integer",
                  info4: "进场类型"
                },
                {
                  info1: "leaveType",
                  info2: "否",
                  info3: "Integer",
                  info4: "离场类型"
                },
                {
                  info1: "invoicingStatus",
                  info2: "否",
                  info3: "Integer",
                  info4: "开票状态 0:未开票 1:纸质票 2:电子票"
                },
                {
                  info1: "invoiceNumber",
                  info2: "否",
                  info3: "String",
                  info4: "发票号码"
                },
                {
                  info1: "vipType",
                  info2: "是",
                  info3: "Integer",
                  info4: "VIP类型"
                },
                {
                  info1: "vipTypeName",
                  info2: "是",
                  info3: "String",
                  info4: "VIP类型名称"
                },
                {
                  info1: "billOriginType",
                  info2: "是",
                  info3: "Integer",
                  info4: "订单来源，0停车场 1,智慧停车 2、开放平台"
                },
                {
                  info1: "payMode",
                  info2: "是",
                  info3: "Integer",
                  info4: "支付方式（<url>参考附录:/Api/appendixData</url>）"
                },
                {
                  info1: "payOrigin",
                  info2: "是",
                  info3: "Integer",
                  info4: "支付来源（<url>参考附录:/Api/appendixData</url>）"
                },
                {
                  info1: "payModeRemark",
                  info2: "是",
                  info3: "String",
                  info4: "支付方式备注"
                },
                {
                  info1: "payOriginRemark",
                  info2: "是",
                  info3: "String",
                  info4: "支付来源备注"
                },
                {
                  info1: "tollCollectorName",
                  info2: "是",
                  info3: "String",
                  info4: "收费员名称"
                },
                {
                  info1: "payTime",
                  info2: "是",
                  info3: "String",
                  info4: "支付时间, yyyyMMddHHmmss"
                },
                {
                  info1: "realValue",
                  info2: "是",
                  info3: "Decimal",
                  info4: "支付金额"
                },
                {
                  info1: "shouldValue",
                  info2: "是",
                  info3: "Decimal",
                  info4: "应收金额"
                },
                {
                  info1: "reliefValue",
                  info2: "是",
                  info3: "Decimal",
                  info4: "优惠减免金额"
                },
                {
                  info1: "couponReliefValue",
                  info2: "是",
                  info3: "Decimal",
                  info4: "优惠券减免金额"
                },
                {
                  info1: "parkReliefScore",
                  info2: "否",
                  info3: "Integer",
                  info4: "车场积分抵扣"
                },
                {
                  info1: "parkReliefValue",
                  info2: "否",
                  info3: "Decimal",
                  info4: "车场积分抵扣金额"
                },
                {
                  info1: "cityReliefScore",
                  info2: "否",
                  info3: "Integer",
                  info4: "城市运营积分抵扣"
                },
                {
                  info1: "cityReliefValue",
                  info2: "否",
                  info3: "Decimal",
                  info4: "城市运营积分抵扣金额"
                },
                {
                  info1: "couponList ",
                  info2: "否",
                  info3: "JsonArray",
                  info4: "支付优惠列表。couponOrigin和reliefType的组合决定优惠的类型：\
                couponOrigin=2 reliefType=0 第三方积分；\
                couponOrigin=2 reliefType=2 第三方优惠（缴费带券）；\
                couponOrigin=2 reliefType=3 第三方优惠；\
                couponOrigin=0 reliefType=0 本地优惠(vems人工优惠)；\
                couponOrigin=0 reliefType=1 电子券优惠；\
                couponOrigin=0 reliefType=2 vems计费系数；\
                couponOrigin=0 reliefType=3 停车场线上活动优惠；\
                couponOrigin=1 reliefType=1 城市运营券优惠；\
                couponOrigin=1 reliefType=2 城市运营积分；"
                },
                        { info1: 'merchantCode', info2: '否', info3: 'String', info4: '入账商户号（通过智慧停车微信缴费）' },
                        { info1: 'bankType', info2: '否', info3: 'String', info4: '付款银行（一点停微信支付才有）' },
                        { info1: 'realInvoiceStatus', info2: '是', info3: 'Integer', info4: '发票状态: 注意阅读\
                        (-1未开票(与invoicingStatus 0 状态对应)，\
                        0新建(提交到开票商未回调-通知平台不能为其账单开票)，\
                        1已开票，\
                        2冲红，\
                        3(已废除)，\
                        4失败(开票商回调不成功为失败))' },
                        { info1: 'invoiceClient', info2: '否', info3: 'String', info4: '开票用户端' },
                        { info1: 'invoiceCooperator', info2: '否', info3: 'String', info4: '开票授权商' },
              ]
            },
            {
              titleName: "couponList",
              tabledata: [
                {tableHead: "参数名", tdName: "info1"},
                {tableHead: "是否必填", tdName: "info2"},
                {tableHead: "类型", tdName: "info3"},
                {tableHead: "说明", tdName: "info4"}
              ],
              td: [
                {info1: "couponOrigin", info2: "是", info3: "int", info4: "优惠来源 0停车场 1智慧停车 2第三方定义优惠"},
                {info1: "reliefType", info2: "否", info3: "Decimal", info4: "与临停缴费上报中的couponType相同。优惠类型：具体对应优惠来源（couponOrigin）所对应的类型, 停车场类型：0本地优惠 1电子券优惠 2vems计费系数 3停车场线上活动优惠，智慧停车类型：1城市运营券优惠 2城市运营积分，第三方类型（针对智慧停车开放平台）：0第三方积分 2第三方优惠（缴费带券） 3第三方优惠"},
                {info1: "reliefName", info2: "否", info3: "String", info4: "优惠名称"},
                {info1: "reliefValue", info2: "否", info3: "Decimal", info4: "减免金额"},
                {info1: "couponCode", info2: "是", info3: "String", info4: "优惠编码"}
              ]
            }
          ],
          codeStatus: [
            {
              titleName: null,
              tabledata: [
                {tableHead: "状态码", tdName: "info1"},
                {tableHead: "说明", tdName: "info2"}
              ],
              td: [
                {info1: "000110", info2: "失败"},
                {info1: "00110000", info2: "失败"},
                {info1: "110000", info2: "失败"}
              ]
            }
          ]
        }
      };
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/getPaymentRecordDetailList.vue